// Generated from shared/pendingFile.mjs by sync-assets.mjs.
// Explicitly retained for an upgrade, on this browser only. Never uploaded here.
const DATABASE = 'instanttranscriber_pending_file_v1';
const POINTER = 'instanttranscriber_pending_file_v1';
const TTL = 60 * 60 * 1000;
function validPurpose(value) { return ['upgrade','audio_tool_reload'].includes(value); }
function database() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, 1);
    request.onupgradeneeded = () => request.result.createObjectStore('files', { keyPath: 'id' });
    request.onerror = () => reject(new Error('local_file_unavailable'));
    request.onblocked = () => reject(new Error('local_file_unavailable'));
    request.onsuccess = () => {
      const db=request.result;
      // A closed tab cannot run a timer. Remove expired/orphaned inputs when
      // this origin next opens the store, before any later access can use them.
      const cleanup=db.transaction('files','readwrite').objectStore('files').openCursor();
      cleanup.onsuccess=()=>{const cursor=cleanup.result;if(!cursor)return;
        if(!Number.isFinite(cursor.value.expires)||cursor.value.expires<=Date.now())cursor.delete();cursor.continue();};
      resolve(db);
    };
  });
}
async function transact(mode, action) {
  const db = await database();
  try {
    return await new Promise((resolve, reject) => {
      const tx = db.transaction('files', mode);
      const request = action(tx.objectStore('files'));
      const timer = setTimeout(() => { try { tx.abort(); } catch {} reject(new Error('local_file_unavailable')); },10000);
      tx.oncomplete = () => { clearTimeout(timer);resolve(request?.result); };
      tx.onerror = tx.onabort = () => { clearTimeout(timer);reject(new Error('local_file_unavailable')); };
    });
  } finally { db.close(); }
}
export async function clearPendingFile(purpose='upgrade') {
  if(!validPurpose(purpose))return;
  let id;
  try{id=sessionStorage.getItem(POINTER+':'+purpose);}catch{}
  if(id)try { await transact('readwrite', store => store.delete(id)); } catch {}
  try { sessionStorage.removeItem(POINTER+':'+purpose); } catch {}
}
export async function retainPendingFile(file,{purpose='upgrade',settings=null}={}) {
  if(!validPurpose(purpose))return false;
  let id;
  try {
    await clearPendingFile(purpose);
    id=crypto.randomUUID();
    await transact('readwrite', store => store.put({ id,purpose,file,name:file.name,lastModified:file.lastModified,settings,expires:Date.now()+TTL }));
    sessionStorage.setItem(POINTER+':'+purpose,id);
    return true;
  } catch {
    if(id)try{await transact('readwrite',store=>store.delete(id));}catch{}
    await clearPendingFile(purpose);return false;
  }
}
export async function readPendingFileInfo(purpose='upgrade') {
  if(!validPurpose(purpose))return null;
  try {
    const id = sessionStorage.getItem(POINTER+':'+purpose);
    if (!id) { await transact('readonly',store=>store.get('__cleanup__'));return null; }
    const value = await transact('readonly', store => store.get(id));
    if (!value || value.purpose!==purpose || value.expires < Date.now() || !(value.file instanceof Blob)) {
      await clearPendingFile(purpose); return null;
    }
    return {...value,file:value.file instanceof File ? value.file
      : new File([value.file],value.name||'recording',{type:value.file.type,lastModified:value.lastModified})};
  } catch { return null; }
}
export async function readPendingFile(purpose='upgrade') { return (await readPendingFileInfo(purpose))?.file||null; }
